import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { HttpClientModule } from "@angular/common/http";
import { BrowserModule } from "@angular/platform-browser";
import {
    AdminFeatureView,
    CatalogContextView,
    SettingPageView,
    DefaultSetupView,
    ThemePageView,
    ThemeConfigView,
    ElementPageView,
    LayoutPageView,
    HeaderPageView,
    HtmlPageView,
    SpeakerPageView,
    TemplateConfigView,
    ImageConfigView,
    RegionConfigView,
    HtmlConfigView,
    LabelConfigView,
    SpeakerSessionsPageView,
    TabsPageView,
    TabConfigView,
    DataPageView,
    GeneralPageView,
    HighlightedPageView,
    GroupingCustomizeDisplaySectionView,
    AdditionalSettingPageView,
    SessionConfigView,
    ButtonConfigView,
    SettingView
} from ".";
import { DefaultPopupView } from "./drawers/popup-drawer/popup-section.view";
import { DefaultDrawerView } from "./drawers/config-drawer/drawer-section.view";
import { cclBuilderDrawerRoutes } from "certain-common-library";
import { CanDeactivateGuard } from "./can-deactivate";
import { CatalogUuidResolver } from "../../modules/shared/resolvers/cataloguuid.resolver";

const featureRoutes: Routes = [
    {
        path: "admin/:catalogUuid",
        resolve: {
            catalog: CatalogUuidResolver
        },
        component: AdminFeatureView,
        children: [
            {
                path: "catalog",
                component: CatalogContextView,
                children: [
                    {
                        path: "setting",
                        component: SettingPageView,
                        children: [
                            {
                                path: "theme",
                                component: ThemePageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            {
                                path: "page-element",
                                component: ElementPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            { path: "**", redirectTo: "page-element" }
                        ]
                    },
                    {
                        path: "layout",
                        component: LayoutPageView,
                        children: [
                            {
                                path: "header",
                                component: HeaderPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            {
                                path: "html-top",
                                component: HtmlPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            {
                                path: "html-bottom",
                                component: HtmlPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            {
                                path: "footer",
                                component: HeaderPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            {
                                path: "highlighted-speaker",
                                component: SpeakerPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            {
                                path: "general-speaker",
                                component: SpeakerPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            {
                                path: "speaker-sessions",
                                component: SpeakerSessionsPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            {
                                path: "tabs",
                                component: TabsPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            {
                                path: "additional-setting",
                                component: AdditionalSettingPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            { path: "**", redirectTo: "header" }
                        ]
                    },
                    {
                        path: 'add-setting',
                        component: SettingView,
                        children: [
                            {
                                path: "additional-setting",
                                component: AdditionalSettingPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            { path: "**", redirectTo: "additional-setting" }
                        ]
                    },
                    {
                        path: "data",
                        component: DataPageView,
                        children: [
                            {
                                path: "highlighted",
                                component: HighlightedPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            {
                                path: "general",
                                component: GeneralPageView,
                                canDeactivate: [CanDeactivateGuard]
                            },
                            { path: "**", redirectTo: "highlighted" }
                        ]
                    },
                    { path: "**", redirectTo: "setting" }
                ]
            },
            { path: "**", redirectTo: "catalog" }
        ]
    },
    {
        outlet: "drawer",
        path: "config-drawer",
        component: DefaultDrawerView,
        children: [
            {
                path: "tab-config",
                component: TabConfigView
            },
            {
                path: "theme-config",
                component: ThemeConfigView
            },
            {
                path: "speaker-sessions",
                children: [
                    {
                        path: "template-config",
                        component: TemplateConfigView
                    },
                    {
                        path: "image-config",
                        component: ImageConfigView
                    },
                    {
                        path: "region-config",
                        component: RegionConfigView
                    },
                    {
                        path: "html-config",
                        component: HtmlConfigView
                    },
                    {
                        path: "label-config",
                        component: LabelConfigView
                    },
                    {
                        path: "session-config",
                        component: SessionConfigView
                    },
                    {
                        path: "button-config",
                        component: ButtonConfigView
                    }
                ]
            },
            {
                path: "speaker",
                children: [
                    {
                        path: "template-config",
                        component: TemplateConfigView
                    },
                    {
                        path: "image-config",
                        component: ImageConfigView
                    },
                    {
                        path: "region-config",
                        component: RegionConfigView
                    },
                    {
                        path: "html-config",
                        component: HtmlConfigView
                    },
                    {
                        path: "label-config",
                        component: LabelConfigView
                    }
                ]
            },
            {
                path: "grouping",
                children: [
                    {
                        path: "customize-display",
                        component: GroupingCustomizeDisplaySectionView
                    }
                ]
            }
        ]
    },
    {
        outlet: "popup",
        path: "popup",
        component: DefaultPopupView,
        children: [
            {
                path: "default-setup",
                component: DefaultSetupView
            }
        ]
    },
    cclBuilderDrawerRoutes
];
@NgModule({
    imports: [RouterModule.forChild(featureRoutes), BrowserModule, HttpClientModule],
    exports: [RouterModule],
    providers: [CatalogUuidResolver]
})
export class AdminFeatureRoutingModule {
    title = "Admin";
}
